import { render, staticRenderFns } from "./QBar.vue?vue&type=template&id=2a245803&"
import script from "./QBar.vue?vue&type=script&lang=js&"
export * from "./QBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports